export const BaseTranslations = {
	"Add to cart": { es: "Añadir", fr: "Ajouter" },
	Added: { es: "Añadido", fr: "Ajouté" },
	available: { es: "disponible", fr: "disponible" },
	Available: { es: "Disponible", fr: "Disponible" },
	Availability: { es: "Disponibilidad", fr: "Disponibilité" },
	Apply: { es: "Aplicar", fr: "Appliquer" },
	"Availability Calendar": {
		es: "Calendario de disponibilidad",
		fr: "Calendrier de disponibilité",
	},
	Back: { es: "Atrás", fr: "Retour" },
	Barcodes: { es: "Códigos de barras", fr: "Codes à barres" },
	"Browse our catalog": {
		es: "Explora nuestro catálogo",
		fr: "Parcourez notre catalogue",
	},
	"Browse the catalog and add items to begin your request.": {
		es: "Explore el catálogo y agregue artículos para comenzar su solicitud.",
		fr: "Parcourez le catalogue et ajoutez des articles pour commencer votre demande.",
	},
	Cancel: { es: "Cancelar", fr: "Annuler" },
	"Cannot request more than then the total available qty.": {
		es: "No se puede solicitar más de la cantidad total disponible.",
		fr: "Il n'est pas possible de demander plus que la quantité totale disponible.",
	},
	CATALOG: { es: "CATÁLOGO", fr: "CATALOGUE" },
	Cart: { es: "Cesta", fr: "Panier" },
	"Change password failed": {
		es: "Error al cambiar la contraseña",
		fr: "Le changement de mot de passe a échoué",
	},
	"Change password was successful": {
		es: "El cambio de contraseña se ha realizado correctamente",
		fr: "Le changement de mot de passe a été effectué avec succès",
	},
	Checkout: { es: "Checkout", fr: "Checkout" },
	"Clear Cart?": { es: "¿Despejar el carro?", fr: "Panier vide ?" },
	"Clear Cart": { es: "Despejar el carro", fr: "Panier vide" },
	"Click to explore": {
		es: "Haz clic para explorar",
		fr: "Cliquez pour explorer",
	},
	"Click on a day to see hourly availability.": {
		es: "Haz clic en un día para ver la disponibilidad por hora.",
		fr: "Cliquez sur un jour pour voir la disponibilité horaire.",
	},
	"Click the menu at the right of each row to get a PDF.": {
		es: "Haz clic en el menu a la derecha de cada fila para obtener un PDF.",
		fr: "Cliquez sur le menu a droite de chaque ligne pour obtenir un PDF.",
	},
	Close: { es: "Cerrar", fr: "Fermer" },
	Class: { es: "Clase", fr: "Classe" },
	Complete: { es: "Completo", fr: "Complet" },
	Collapse: { es: "Colapso", fr: "Effondrement" },
	"Collapse Sidebar": {
		es: "Contraer barra lateral",
		fr: "Réduire la barre latérale",
	},
	"Contact Info": {
		es: "Información de contacto",
		fr: "Informations de contact",
	},
	Copy: { es: "Copiar", fr: "Copie" },
	day: { es: "día", fr: "jour" },
	days: { es: "días", fr: "jours" },
	daily: { es: "diario", fr: "quotidien" },
	Daily: { es: "Diario", fr: "Quotidien" },
	Description: { es: "Descripción", fr: "Description" },
	Delete: { es: "Borrar", fr: "Supprimer" },
	"Don't have an account?": {
		es: "¿No tienes una cuenta?",
		fr: "Vous n'avez pas de compte?",
	},
	Email: { es: "Correo electrónico", fr: "Courriel" },
	"Email is required": {
		es: "Correo electrónico obligatorio",
		fr: "L'adresse électronique est requise",
	},
	"Equipment Requests": {
		es: "Solicitudes de equipo",
		fr: "Demandes d'equipement",
	},
	"Enter a valid email address": {
		es: "Introduzca una dirección de correo electrónico válida",
		fr: "Entrez une adresse e-mail valide",
	},
	"Enter your contact info and ask a question about an item.": {
		es: "Ingrese su información de contacto y haga una pregunta sobre un artículo.",
		fr: "Saisissez vos coordonnées et posez une question sur un article.",
	},
	"Enter your email to login to your account": {
		es: "Introduzca su correo electrónico para iniciar sesión en su cuenta",
		fr: "Saisissez votre e-mail pour vous connecter a votre compte",
	},
	"End Date": { es: "Fecha final", fr: "Date de fin" },
	Expand: { es: "Ampliar", fr: "Élargir" },
	"Expand Sidebar": {
		es: "Expandir barra lateral",
		fr: "Développer la barre latérale",
	},
	"Export Cart": { es: "Cesta de exportación", fr: "Panier d'exportation" },
	"First Name": { es: "Nombre", fr: "Prénom" },
	"First Name is required": {
		es: "El nombre es obligatorio",
		fr: "Le prénom est obligatoire",
	},
	"For rent": { es: "En alquiler", fr: "A louer" },
	"For sale": { es: "Se vende", fr: "A vendre" },
	"Pickup is not permitted on holidays": {
		es: "No se permite la recogida en días festivos",
		fr: "Le retrait n'est pas autorisé les jours fériés",
	},
	"Fill out the fields to signup for a new account": {
		es: "Complete los campos para crear una cuenta nueva",
		fr: "Remplissez les champs pour creer un nouveau compte",
	},
	Friday: { es: "viernes", fr: "vendredi" },
	"Forgot your password?": {
		es: "¿Olvidaste tu contraseña?",
		fr: "Vous avez oublié votre mot de passe?",
	},
	From: { es: "De", fr: "De" },
	"Return is not permitted on holidays": {
		es: "No se permite la devolución en días festivos",
		fr: "Le retour n'est pas autorisé les jours fériés",
	},
	"Unable to validate reservation dates": {
		es: "No se pueden validar las fechas de reserva",
		fr: "Impossible de valider les dates de réservation",
	},
	"Grid View": { es: "Vista en cuadrícula", fr: "Vue en grille" },
	"Hide accessories": {
		es: "Ocultar accesorios",
		fr: "Cacher les accessoires",
	},
	"Hours of Operation": {
		es: "Horario de atención",
		fr: "Horaires d'ouverture",
	},
	"Hour detail is enabled for this storefront.": {
		es: "El detalle por hora está habilitado para esta tienda.",
		fr: "Le détail horaire est activé pour cette vitrine.",
	},
	"Hour detail is hidden by storefront settings.": {
		es: "El detalle por hora está oculto por la configuración de la tienda.",
		fr: "Le détail horaire est masqué par les paramètres de la vitrine.",
	},
	Time: { es: "Hora", fr: "Heure" },
	Hour: { es: "Hora", fr: "Heure" },
	hour: { es: "hora", fr: "heure" },
	hours: { es: "horas", fr: "heures" },
	Minute: { es: "Minuto", fr: "Minute" },
	"AM/PM": { es: "AM/PM", fr: "AM/PM" },
	"Select time": {
		es: "Seleccionar hora",
		fr: "SÃ©lectionner l'heure",
	},
	Done: { es: "Listo", fr: "TerminÃ©" },
	"Open Days": {
		es: "Días abiertos",
		fr: "Jours d'ouverture",
	},
	Image: { es: "Imagen", fr: "Image" },
	"Import Cart": { es: "Cesta de importación", fr: "Panier d'importation" },
	"Important shopping cart messages": {
		es: "Mensajes importantes del carrito de compras",
		fr: "Messages importants du panier d'achat",
	},
	"in cart": { es: "en carro", fr: "dans le panier" },
	Inquire: { es: "Consulte", fr: "Demander" },
	"Inquire about": { es: "Consulta sobre", fr: "Se renseigner sur" },
	"Inquiry sent": { es: "Consulta enviada", fr: "Demande envoyée" },
	Invoices: { es: "Facturas", fr: "Factures" },
	"Invalid date range": {
		es: "Rango de fechas no válido",
		fr: "Plage de dates non valide",
	},
	"Invalid quantity": { es: "Cantidad no válida", fr: "Quantité non valide" },
	"Invalid from date. The shop is closed on ": {
		es: "Fecha de inicio inválida. La tienda está cerrada el ",
		fr: "Date de début non valide. La boutique est fermée le ",
	},
	"Invalid to date. The shop is closed on ": {
		es: "Fecha de fin no válida. La tienda está cerrada el",
		fr: "Date de fin non valide. Le magasin est fermé le",
	},
	"Invalid start time": {
		es: "Hora de inicio no válida",
		fr: "Heure de début non valide",
	},
	"Invalid end time": {
		es: "Hora de fin no válida",
		fr: "Heure de fin non valide",
	},
	"Start date/time must not be in the past": {
		es: "La fecha/hora de inicio no debe estar en el pasado",
		fr: "La date/heure de dÃ©but ne doit pas Ãªtre dans le passÃ©",
	},
	"Reservation must be at least ": {
		es: "La reserva debe ser de al menos ",
		fr: "La rÃ©servation doit durer au moins ",
	},
	"Reservation must be no more than ": {
		es: "La reserva no debe exceder ",
		fr: "La rÃ©servation ne doit pas dÃ©passer ",
	},
	"Start time must be within hours of operation": {
		es: "La hora de inicio debe estar dentro del horario de atención",
		fr: "L'heure de début doit être comprise dans les horaires d'ouverture",
	},
	"End time must be within hours of operation": {
		es: "La hora de fin debe estar dentro del horario de atención",
		fr: "L'heure de fin doit être comprise dans les horaires d'ouverture",
	},
	"Unable to validate times against hours of operation": {
		es: "No se pueden validar las horas con el horario de atención",
		fr: "Impossible de valider les heures avec les horaires d'ouverture",
	},
	Inventory: { es: "Inventario", fr: "Inventaire" },
	Item: { es: "Artículo", fr: "Objet" },
	items: { es: "artículos", fr: "objets" },
	"Item Name": { es: "Nombre del artículo", fr: "Nom de l'article" },
	"Item No": { es: "Nº de artículo", fr: "Numéro d'article" },
	Job: { es: "Trabajo", fr: "Travail" },
	Kit: { es: "Kit", fr: "Kit" },
	Keywords: { es: "Palabras clave", fr: "Mots clés" },
	"Last Name": { es: "Apellido", fr: "Nom de famille" },
	"Last Name is required": {
		es: "Apellido obligatorio",
		fr: "Le nom de famille est obligatoire",
	},
	Language: { es: "Idioma", fr: "Langue" },
	Link: { es: "Enlace", fr: "Lien" },
	"List View": { es: "Ver lista", fr: "Vue de la liste" },
	Location: { es: "Ubicación", fr: "Localisation" },
	Login: { es: "Inicio sesión", fr: "Login" },
	"Login successful": {
		es: "Inicio de sesión exitoso",
		fr: "Connexion reussie",
	},
	"Login with Microsoft": {
		es: "Iniciar sesión con Microsoft",
		fr: "Se connecter avec Microsoft",
	},
	"Login with your Microsoft Entra ID account": {
		es: "Inicia sesión con tu cuenta de Microsoft Entra ID",
		fr: "Connectez-vous avec votre compte Microsoft Entra ID",
	},
	month: { es: "mes", fr: "mois" },
	Month: { es: "Mes", fr: "Mois" },
	Mon: { es: "Lun", fr: "Lun" },
	Manufacturer: { es: "Fabricante", fr: "Fabricant" },
	"Manufacturer URL": { es: "URL del fabricante", fr: "URL du fabricant" },
	"Manufacturer Part Number": {
		es: "Número de pieza del fabricante",
		fr: "Numéro de pièce du fabricant",
	},
	Message: { es: "Mensaje", fr: "Message" },
	"Message is required": {
		es: "El mensaje es obligatorio",
		fr: "Le message est obligatoire",
	},
	Monday: { es: "lunes", fr: "lundi" },
	monthly: { es: "mensualmente", fr: "mensuel" },
	Monthly: { es: "Mensualmente", fr: "Mensuel" },
	"Must be number": { es: "Debe ser un número", fr: "Doit être un nombre" },
	"New Job": { es: "Nuevo trabajo", fr: "Nouveau travail" },
	Next: { es: "Siguiente", fr: "Suivant" },
	"Next month": { es: "Mes siguiente", fr: "Mois suivant" },
	"No products found": {
		es: "No se encontraron productos",
		fr: "Aucun produit trouvé",
	},
	"No availability events for this day.": {
		es: "No hay eventos de disponibilidad para este día.",
		fr: "Aucun événement de disponibilité pour ce jour.",
	},
	Notes: { es: "Notas", fr: "Notes" },
	Number: { es: "Número", fr: "Nombre" },
	of: { es: "de", fr: "de" },
	OK: { es: "OK", fr: "OK" },
	"Optional accessories": {
		es: "Accesorios opcionales",
		fr: "Accessoires en option",
	},
	"Order Description": {
		es: "Descripción del pedido",
		fr: "Description de la commande",
	},
	Orders: { es: "Pedidos", fr: "Commandes" },
	package: { es: "paquete", fr: "paquet" },
	"Package includes": { es: "El paquete incluye", fr: "Le paquet comprend" },
	Page: { es: "Página", fr: "Page" },
	Password: { es: "Contraseña", fr: "Mot de passe" },
	"Password is required": {
		es: "La contraseña es obligatoria",
		fr: "Le mot de passe est obligatoire",
	},
	Phone: { es: "Teléfono", fr: "Téléphone" },
	"Phone is required": {
		es: "Teléfono obligatorio",
		fr: "Le téléphone est obligatoire",
	},
	"Please resolve the errors in the cart.": {
		es: "Por favor, resuelva los errores en el carrito.",
		fr: "Veuillez résoudre les erreurs dans le panier.",
	},
	Print: { es: "Imprimir", fr: "Imprimer" },
	Previous: { es: "Anterior", fr: "Précédent" },
	"Previous month": { es: "Mes anterior", fr: "Mois précédent" },
	Price: { es: "Precio", fr: "Prix" },
	Qty: { es: "Ctd", fr: "Qté" },
	"Qty in cart": { es: "Ctd en cesta", fr: "Qté en panier" },
	Quantity: { es: "Cantidad", fr: "Quantité" },
	"Quote Description": {
		es: "Descripción de el presupuesto",
		fr: "Description du devis",
	},
	"Quote & Orders": { es: "Cotizaciones y pedidos", fr: "Devis et commandes" },
	"Quote Request": { es: "Solicitud de presupuesto", fr: "Demande de devis" },
	Rate: { es: "Tarifa", fr: "Taux" },
	Register: { es: "Registrarse", fr: "S'inscrire" },
	Receiving: { es: "Entrante", fr: "Réception" },
	Removed: { es: "Eliminado", fr: "Supprimé" },
	"Rental Dates": { es: "Fechas de alquiler", fr: "Dates de location" },
	"Replacement Cost": {
		es: "Coste de sustitución",
		fr: "Coût de remplacement",
	},
	"Request Quote": { es: "Solicitar presupuesto", fr: "Demande de devis" },
	"Reservation Dates": {
		es: "Fechas de la reserva",
		fr: "Dates de réservation",
	},
	"Reservations for different date ranges must be submitted as separate Orders":
		{
			es: "Las reservas para distintos intervalos de fechas deben presentarse como pedidos separados",
			fr: "Les réservations pour des plages de dates différentes doivent faire l'objet de commandes distinctes",
		},
	Status: { es: "Estado", fr: "Statut" },
	"Store Availability Info": {
		es: "Información de disponibilidad de la tienda",
		fr: "Informations sur la disponibilité du magasin",
	},
	"The shop is closed for the selected week.": {
		es: "La tienda está cerrada durante la semana seleccionada.",
		fr: "Le magasin est fermé pour la semaine sélectionnée.",
	},
	"Reset password failed": {
		es: "Error al restablecer la contraseña",
		fr: "Échec de la réinitialisation du mot de passe",
	},
	JanShort: { es: "Ene", fr: "Jan" },
	FebShort: { es: "Feb", fr: "Fév" },
	MarShort: { es: "Mar", fr: "Mar" },
	AprShort: { es: "Abr", fr: "Avr" },
	MayShort: { es: "May", fr: "Mai" },
	JunShort: { es: "Jun", fr: "Juin" },
	JulShort: { es: "Jul", fr: "Juil" },
	AugShort: { es: "Ago", fr: "Aoû" },
	SepShort: { es: "Sep", fr: "Sep" },
	OctShort: { es: "Oct", fr: "Oct" },
	NovShort: { es: "Nov", fr: "Nov" },
	DecShort: { es: "Dic", fr: "Déc" },
	January: { es: "Enero", fr: "Janvier" },
	February: { es: "Febrero", fr: "Février" },
	March: { es: "Marzo", fr: "Mars" },
	April: { es: "Abril", fr: "Avril" },
	May: { es: "Mayo", fr: "Mai" },
	June: { es: "Junio", fr: "Juin" },
	July: { es: "Julio", fr: "Juillet" },
	August: { es: "Agosto", fr: "Août" },
	September: { es: "Septiembre", fr: "Septembre" },
	October: { es: "Octubre", fr: "Octobre" },
	November: { es: "Noviembre", fr: "Novembre" },
	December: { es: "Diciembre", fr: "Décembre" },
	"Reset password email was sent to": {
		es: "Se ha enviado un correo electrónico de restablecimiento de contraseña a",
		fr: "Le courriel de réinitialisation du mot de passe a été envoyé à",
	},
	"Reset password was successful": {
		es: "La contraseña se ha restablecido correctamente",
		fr: "La réinitialisation du mot de passe a réussi",
	},
	"Reset Password": {
		es: "Restablecer contraseña",
		fr: "Réinitialiser le mot de passe",
	},
	"Reset Range": { es: "Restablecer rango", fr: "Réinitialiser la plage" },
	Saturday: { es: "sábado", fr: "samedi" },
	Search: { es: "Buscar", fr: "Recherche" },
	"Search Options": { es: "Opciones de búsqueda", fr: "Options de recherche" },
	Select: { es: "Seleccionar", fr: "Sélectionner" },
	"Selected Quantity cannot exceed available": {
		es: "La cantidad seleccionada no puede exceder la disponible.",
		fr: "La quantité sélectionnée ne peut pas dépasser la disponibilité",
	},
	Send: { es: "Enviar", fr: "Envoyer" },
	"Sending reset password email failed": {
		es: "Error al enviar el correo electrónico de restablecimiento de contraseña",
		fr: "L'envoi de l'e-mail de réinitialisation du mot de passe a échoué",
	},
	"Sends an email with a reset password link.": {
		es: "Envia un correo electronico con un enlace para restablecer la contraseña.",
		fr: "Envoie un e-mail avec un lien de reinitialisation du mot de passe.",
	},
	"Please fill out any remaining fields and make sure the reservation dates are correct.":
		{
			es: "Por favor, complete los campos restantes y asegurese de que las fechas de reserva sean correctas.",
			fr: "Veuillez remplir tous les champs restants et vous assurer que les dates de reservation sont correctes.",
		},
	Share: { es: "Compartir", fr: "Partager" },
	"Shipping Weight": { es: "Peso del envío", fr: "Poids d'expédition" },
	"Shopping Cart": { es: "Cesta de la compra", fr: "Panier d'achat" },
	"Your shopping cart is empty.": {
		es: "Su carrito de compras está vacío.",
		fr: "Votre panier est vide.",
	},
	"Start Date": { es: "Fecha de inicio", fr: "Date de début" },
	"Stop Date": { es: "Fecha de finalización", fr: "Date d'arrêt" },
	Submit: { es: "Enviar", fr: "Soumettre" },
	"Submit Equipment Request": {
		es: "Enviar solicitud de presupuesto",
		fr: "Soumettre une demande de devis",
	},
	"Submit Order": { es: "Enviar pedido", fr: "Soumettre la commande" },
	"Submit Request for Quote": {
		es: "Enviar solicitud de presupuesto",
		fr: "Soumettre une demande de devis",
	},
	Submitted: {
		es: "Enviado",
		fr: "Envoyé",
	},
	Submitting: {
		es: "Enviando",
		fr: "Envoi en cours",
	},
	Sugggested: { es: "Sugerencia", fr: "Suggéré" },
	Signup: { es: "Registrate", fr: "Inscrivez-vous" },
	Sun: { es: "Dom", fr: "Dim" },
	"Student ID": { es: "ID de estudiante", fr: "ID etudiant" },
	"Student ID is required": {
		es: "El ID de estudiante es obligatorio",
		fr: "L'ID étudiant est obligatoire",
	},
	Sunday: { es: "domingo", fr: "dimanche" },
	Tags: { es: "Tags", fr: "Tags" },
	"Technical Notes": { es: "Notas técnicas", fr: "Notes techniques" },
	"Thumbnail Size": {
		es: "Tamaño de la miniatura",
		fr: "Taille de la vignette",
	},
	Thursday: { es: "jueves", fr: "jeudi" },
	Thu: { es: "Jue", fr: "Jeu" },
	"Total Items": { es: "Total de artículos", fr: "Total des articles" },
	To: { es: "A", fr: "A" },
	Tue: { es: "Mar", fr: "Mar" },
	"Try adjusting your search criteria or browse different categories": {
		es: "Intenta ajustar tus criterios de búsqueda o explorar diferentes categorías",
		fr: "Essayez d’ajuster vos critères de recherche ou de parcourir différentes catégories",
	},
	"Toggle password visibility": {
		es: "Mostrar u ocultar contraseña",
		fr: "Afficher ou masquer le mot de passe",
	},
	Tuesday: { es: "martes", fr: "mardi" },
	Unavailable: { es: "No disponible", fr: "Indisponible" },
	"Unable to send inquiry": {
		es: "No se puede enviar la consulta",
		fr: "Impossible d'envoyer une demande de renseignements",
	},
	"Update cart": { es: "Actualizar", fr: "Mise à jour" },
	Updated: { es: "Actualizado", fr: "Mise à jour" },
	"View accessories": { es: "Ver accesorios", fr: "Voir les accessoires" },
	"View Catalog": { es: "Ver Catálogo", fr: "Voir le Catalogue" },
	Warehouse: { es: "Almacén", fr: "Entrepôt" },
	"Welcome to": { es: "Bienvenido a", fr: "Bienvenue à" },
	Wed: { es: "Mié", fr: "Mer" },
	Wednesday: { es: "miércoles", fr: "mercredi" },
	week: { es: "semana", fr: "semaine" },
	weekly: { es: "semanal", fr: "hebdomadaire" },
	Weekly: { es: "Semanal", fr: "Hebdomadaire" },
	Fri: { es: "Vie", fr: "Ven" },
	Sat: { es: "Sáb", fr: "Sam" },
	Day: { es: "Día", fr: "Jour" },
	"All day": { es: "Todo el día", fr: "Toute la journée" },
	"Week view switched to the readable event list because overlapping hourly events were detected.":
		{
			es: "La vista semanal cambió a la lista legible de eventos porque se detectaron eventos horarios superpuestos.",
			fr: "La vue hebdomadaire a basculé vers la liste d'événements lisible parce que des événements horaires qui se chevauchent ont été détectés.",
		},
	Loading: { es: "Cargando", fr: "Chargement" },
};
